import { useId, useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { useTracker } from "@ferrivia/auth-web";
import type { EventProperties } from "@ferrivia/analytics/browser";
import s from "./Disclosure.module.css";

type SummarySectionId = EventProperties<"summary.disclosure_toggled">["section_id"];

export interface DisclosureProps {
  sectionId: SummarySectionId;
  foldedLabel: ReactNode;
  openLabel: ReactNode;
  children: ReactNode;
}

export function Disclosure({ sectionId, foldedLabel, openLabel, children }: DisclosureProps) {
  const tracker = useTracker();
  const [open, setOpen] = useState(false);
  const regionId = useId();

  function toggle() {
    setOpen(!open);
    tracker.track("summary.disclosure_toggled", { section_id: sectionId, expanded: !open });
  }

  return (
    <div className={s.root} data-open={open}>
      <button type="button" className={s.button} aria-expanded={open} aria-controls={regionId} onClick={toggle}>
        <span className={s.label}>{open ? openLabel : foldedLabel}</span>
        <ChevronDown aria-hidden size={18} className={s.chevron} />
      </button>
      <div id={regionId} className={s.region} hidden={!open}>
        {children}
      </div>
    </div>
  );
}
